import React from "react";

import RAGIndicatorNew from "components/visuals/RAGIndicatorNew";

import { useAppSelector } from "store";
import { selectRetailersAlignmentStatus } from "modules/customer/tools/location/retailers/retailersSlice";

const RetailersAlignment: React.FC = () => {
    const retailersAlignment = useAppSelector(selectRetailersAlignmentStatus);
    return (
        <RAGIndicatorNew ragIndicator={retailersAlignment} />
    );
};

export default RetailersAlignment;
